import React, {useEffect} from 'react';
import { connect } from 'react-redux';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import POSPanel from '@flows/POSPanel';
import { getRoomLabelText } from '@src/utilities/common';
import './POS.scss';

const POS = ({cart, tabs, selectedRestaurant: _selectedRestaurant}: any) => {
    const [value, setValue]:any = React.useState(null);
    const [mainVal, setMainVal]:any = React.useState(null);
    const [badgeCount, setBadgeCount]:any = React.useState({});

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const handleChangeMain = (event: React.SyntheticEvent, newValue: string) => {
        setMainVal(newValue);
        setValue(newValue+"-1");
    };

    useEffect(() => {
        // let localData = localStorage.getItem('RESTAURANTS_DATA') ? JSON.parse(localStorage.getItem('RESTAURANTS_DATA') || '') : "";
        // let resId = params?.restaurantId;
        if(tabs) {
            var tempSelected = Object.entries(tabs).sort().reverse() || null;
            if(tempSelected && tempSelected[0] && tempSelected[0][0]){
                setMainVal(tempSelected[0][0]);
                setValue(tempSelected[0][0]+"-1");
            }
        }
    }, [tabs]);

    useEffect(() => {
        let tempCount:any = {};
        !!cart && Object.keys(cart).forEach(key => {
            if(!tempCount[key?.split("-")[0]]) {
                tempCount[key?.split("-")[0]] = {};
            }
            let tempCheck = !!cart[key] && Object.keys(cart[key]).filter(keyP => cart[key][keyP] !== null)?.length;
            if(tempCheck){
                if(!tempCount[key?.split("-")[0]][key]){
                    tempCount[key?.split("-")[0]][key] = null;
                }
                tempCount[key?.split("-")[0]][key] = tempCheck;
            }
        });
        setBadgeCount(tempCount);
    }, [cart]);

    return (
        <>
            <Box>
                {value && !!tabs && Object.entries(tabs).length > 1 && <Tabs
                    value={mainVal}
                    onChange={handleChangeMain}
                    variant="scrollable"
                    sx={{ bgcolor: 'var(--primary-light-dark)' }}
                    className='topPOSHeader mainCat'
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                >
                    {
                        !!tabs && Object.entries(tabs).sort().reverse().map(([key, _val]:any, _index:number) => (
                            <Tab key={key} sx={{ fontWeight: 'bold', minHeight: 'auto' }} value={key} label={key} disableRipple icon={(!!badgeCount[key] && Object.keys(badgeCount[key])?.length) ? <span className='tabBadge'>{(!!badgeCount[key] && Object.keys(badgeCount[key])?.length)}</span> : <></>} />
                        ))
                    }
                </Tabs>}

                {value && !!tabs && Object.entries(tabs).length && <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    sx={{ bgcolor: 'var(--primary-light)'}}
                    scrollButtons="auto"
                    className='topPOSHeader subCat'
                    aria-label="scrollable auto tabs example"
                >
                    {
                        Array.from(Array(tabs[mainVal])).map((table: any, num: any) => (
                            <Tab key={`${mainVal}-${num}`} sx={{ fontWeight: 'bold', minHeight: 'auto' }} value={`${mainVal}-${num+1}`} label={getRoomLabelText(mainVal, num + 1)} disableRipple icon={badgeCount[mainVal] && badgeCount[mainVal][`${mainVal}-${num+1}`] ? <span className='tabBadge'>{badgeCount[mainVal][`${mainVal}-${num+1}`]}</span> : <></>} />
                        ))
                    }
                </Tabs>}
                <POSPanel type="admin" tableNumber={value} />
            </Box>
        </>
    )};

const mapStateToProps = (state: any) => {
    const { cart, common } = state;

    return {
        cart: (cart && cart[common?.selectedRestaurant?.docId]) || {},
        selectedRestaurant: common?.selectedRestaurant || {},
        tabs: common?.selectedRestaurant?.tabs || {},
    }
}

export default connect(mapStateToProps)(POS)
